import { useMemo } from "react"

import { useGetBaseCompanies } from "./useGetBaseCompanies"

import { CompanyAccountingType, CompanyStatus } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

const DISTRIBUTOR_FILTER = {
  types: [CompanyAccountingType.Customer, CompanyAccountingType.Vendor],
  statuses: [CompanyStatus.Active],
}

interface UseDistributorOptionsReturn {
  distributorOptions: Option<string>[]
  isLoadingDistributors: boolean
}

export const useDistributorOptions = (): UseDistributorOptionsReturn => {
  const { companies, isFetchingCompanies } = useGetBaseCompanies(DISTRIBUTOR_FILTER, false, 10000)

  const distributorOptions = useMemo(
    () =>
      companies.map((company) => ({
        value: company.companyId,
        label: company.name ?? "",
      })),
    [companies]
  )

  return {
    distributorOptions,
    isLoadingDistributors: isFetchingCompanies,
  }
}
